import LetsTalk from "pages/LetsTalk";
import PrivacyPolicy from "pages/PrivacyPolicy";
import Terms from "pages/terms";

export const APP_URL = {
  HomePage: 'home',
  CommunityPage: 'community',
  LetsTalkPage: 'letstalk',
  MeetMePage: 'meetme',
  PrivacyPolicyPage: 'privacypolicy',
  ServicePage: 'service',
  TermsPage: 'terms',
  NotFound: 'notfound'
};